import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, Toast } from "@/components/Layout";
import { downloadFile } from "@/lib/download";
import api from "@/lib/api";

const errText = (e) => e?.response?.data?.detail || "Eroare";
const f2 = (n) => (n || n === 0 ? (Math.round(n * 100) / 100).toLocaleString("ro-RO") : "—");
const prevMonth = () => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; };

/** Calculul lunar al plății cu ora, din fișele APROBATE, și exportul Excel pentru Serviciul Salarizare. */
export default function PhPayroll() {
  const [month, setMonth] = useState(prevMonth());
  const [data, setData] = useState(null);
  const [msg, setMsg] = useState({ text: "", type: "info" });
  const [y, m] = month.split("-").map(Number);
  useEffect(() => {
    setData(null);
    api.get("/stat-didactic/ph/time/payroll", { params: { year: y, month: m } }).then(r => setData(r.data)).catch(e => { setData({ items: [], totals: {} }); setMsg({ text: errText(e), type: "error" }); });
  }, [month]); // eslint-disable-line react-hooks/exhaustive-deps
  const exportXlsx = async () => { try { await downloadFile(`/stat-didactic/ph/time/payroll.xlsx?year=${y}&month=${m}`, "plata_cu_ora.xlsx"); } catch (e) { setMsg({ text: e.message, type: "error" }); } };
  return (
    <>
      <PageHeader title="Plata cu ora — calcul pentru Salarizare" subtitle="Doar fișele de pontaj aprobate; suma = ore × tariful funcției de salarizare"
        actions={<Link className="btn btn-secondary" to="/stat-didactic/plata-ora">Înapoi la plata cu ora</Link>} />
      <Toast msg={msg.text} type={msg.type} />
      <div style={{ display: "flex", gap: 12, alignItems: "flex-end", marginBottom: 14 }}>
        <div><label className="label">Luna</label><input className="input" type="month" value={month} onChange={e => setMonth(e.target.value)} data-testid="sfd-php-pay-month" /></div>
        <button className="btn btn-primary" onClick={exportXlsx} disabled={!data || data.items.length === 0} data-testid="sfd-php-pay-export">Export Excel</button>
      </div>
      {!data ? <div>Se încarcă...</div> : (
        <div className="card">
          <table className="tbl" data-testid="sfd-php-pay-table">
            <thead><tr><th>Candidat</th><th>Calitatea</th><th>Facultatea</th><th>Departamentul</th><th>Funcția de salarizare</th><th className="tabular-nums">Tarif</th><th className="tabular-nums">Ore fizice</th><th className="tabular-nums">Ore conv.</th><th className="tabular-nums">Sumă brută (lei)</th></tr></thead>
            <tbody>
              {data.items.length === 0 && <tr><td colSpan={9} style={{ color: "#64748B" }}>Nicio fișă aprobată în această lună.</td></tr>}
              {data.items.flatMap(it => it.breakdown.map((g, i) => (
                <tr key={it.application_id + g.pay_function} data-testid={`sfd-php-pay-row-${it.name}`}>
                  <td style={{ fontWeight: 600 }}>{i === 0 ? it.name : ""}</td><td>{i === 0 ? (it.kind === "titular" ? "titular" : "asociat") : ""}</td><td>{i === 0 ? it.faculty : ""}</td><td>{i === 0 ? it.department : ""}</td>
                  <td>{g.pay_function_label}</td><td className="tabular-nums">{f2(g.tariff)}</td><td className="tabular-nums">{f2(g.physical)}</td><td className="tabular-nums">{f2(g.conventional)}</td><td className="tabular-nums">{f2(g.amount)}</td>
                </tr>)))}
              {data.items.length > 0 && <tr style={{ fontWeight: 700 }}><td colSpan={6}>TOTAL</td><td className="tabular-nums">{f2(data.totals.physical)}</td><td className="tabular-nums">{f2(data.totals.conventional)}</td><td className="tabular-nums" data-testid="sfd-php-pay-total">{f2(data.totals.amount)}</td></tr>}
            </tbody>
          </table>
        </div>)}
    </>
  );
}
